import { render } from "./TheFaqAccordion.vue?vue&type=template&id=9781a5f2"
import script from "./TheFaqAccordion.vue?vue&type=script&lang=js"
export * from "./TheFaqAccordion.vue?vue&type=script&lang=js"
script.render = render

export default script